var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-screen-adapter",style:(`background-color: ${_vm.$route.meta.bgColor}`)},[_c('div',{staticClass:"screen",style:(`width: ${_vm.$route.meta.basicScreenWidth}px;height: ${_vm.$route.meta.basicScreenHeight}px`),attrs:{"id":"screen"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }